import { EFaaliyet } from 'src/enums/mixed.enum';

type TFaaliyetData = Record<
  EFaaliyet,
  {
    en: string;
    tr: string;
    ar: string;
    es: string;
    it: string;
    ro: string;
  }
>;

const data: TFaaliyetData = {
  [EFaaliyet.BOS]: {
    en: 'Wiped Out',
    tr: 'Boş',
    ar: 'مسح',
    es: 'Wiped Out',
    it: 'Wiped Out',
    ro: 'Wiped Out',
  },
  [EFaaliyet.ETKISIZ]: {
    en: 'Ineffective',
    tr: 'Etkisiz',
    ar: 'غير فعال',
    es: 'Ineffective',
    it: 'Ineffective',
    ro: 'Ineffective',
  },
  [EFaaliyet.GUNLUK]: {
    en: 'Routine',
    tr: 'Günlük',
    ar: 'روتيني',
    es: 'Routine',
    it: 'Routine',
    ro: 'Routine',
  },
  [EFaaliyet.HARP_ESIRI]: {
    en: 'Prisoner of War',
    tr: 'Harp Esiri',
    ar: 'أسير حرب',
    es: 'Prisoner of War',
    it: 'Prisoner of War',
    ro: 'Prisoner of War',
  },
  [EFaaliyet.INTIKAL]: {
    en: 'Move',
    tr: 'Intikal',
    ar: 'تحرك',
    es: 'Move',
    it: 'Move',
    ro: 'Move',
  },
  [EFaaliyet.KESIF]: {
    en: 'Recce',
    tr: 'Keşif',
    ar: 'استطلاع',
    es: 'Recce',
    it: 'Recce',
    ro: 'Recce',
  },
  [EFaaliyet.SAVUNMA]: {
    en: 'Defend',
    tr: 'Savunma',
    ar: 'دفاع',
    es: 'Defend',
    it: 'Defend',
    ro: 'Defend',
  },
  [EFaaliyet.EYP_YERLESTIRME]: {
    en: 'Lay IED',
    tr: 'EYP Yerleştirme',
    ar: 'زرع العبوة الناسفة',
    es: 'Lay IED',
    it: 'Lay IED',
    ro: 'Lay IED',
  },
  [EFaaliyet.GOREREK_ATIS]: {
    en: 'Direct Fire',
    tr: 'Görerek Atış',
    ar: 'إطلاق نار مباشر',
    es: 'Direct Fire',
    it: 'Direct Fire',
    ro: 'Direct Fire',
  },
  [EFaaliyet.GORMEYEREK_ATIS]: {
    en: 'Indirect Fire',
    tr: 'Görmeyerek Atış',
    ar: 'إطلاق نار غير مباشر',
    es: 'Indirect Fire',
    it: 'Indirect Fire',
    ro: 'Indirect Fire',
  },
  [EFaaliyet.TAARRUZ]: {
    en: 'Attack',
    tr: 'Taaruz',
    ar: 'هجوم',
    es: 'Attack',
    it: 'Attack',
    ro: 'Attack',
  },
  [EFaaliyet.EYP_TEMIZLIGI]: {
    en: 'Clear IED',
    tr: 'EYP Temizliği',
    ar: 'تطهير العبوة الناسفة',
    es: 'Clear IED',
    it: 'Clear IED',
    ro: 'Clear IED',
  },
  [EFaaliyet.KARA_HAVA_FUZESI_ANGAJMANI]: {
    en: 'Surface to Air Missile Engagement',
    tr: 'Hava Savunma Topçu Atışı',
    ar: 'اشتباك صاروخي أرض-جو',
    es: 'Surface to Air Missile Engagement',
    it: 'Surface to Air Missile Engagement',
    ro: 'Surface to Air Missile Engagement',
  },
  [EFaaliyet.KBRN_DEKONTAMINASYON]: {
    en: 'CBRN Decontamination',
    tr: 'KBRN Dekontaminasyon',
    ar: 'إزالة تلوث كيميائي بيولوجي إشعاعي نووي',
    es: 'CBRN Decontamination',
    it: 'CBRN Decontamination',
    ro: 'CBRN Decontamination',
  },
  [EFaaliyet.YAKIN_HAVA_DESTEGI]: {
    en: 'Close Air Support',
    tr: 'Yakın Hava Desteği',
    ar: 'إسناد جوي قريب',
    es: 'Close Air Support',
    it: 'Close Air Support',
    ro: 'Close Air Support',
  },
  [EFaaliyet.DENIZ_TOPCUSU_DESTEGI]: {
    en: 'Naval Fire Support',
    tr: 'Deniz Topcusu Desteği',
    ar: 'دعم ناري بحري',
    es: 'Naval Fire Support',
    it: 'Naval Fire Support',
    ro: 'Naval Fire Support',
  },
  [EFaaliyet.NIZAM]: {
    en: 'Formation',
    tr: 'Nizam',
    ar: 'تشكيل',
    es: 'Formation',
    it: 'Formation',
    ro: 'Formation',
  },
  [EFaaliyet.GERI_CEKILME]: {
    en: 'Withdraw',
    tr: 'Geri Çekilme',
    ar: 'انسحاب',
    es: 'Withdraw',
    it: 'Withdraw',
    ro: 'Withdraw',
  },
  [EFaaliyet.HAVA_GOREVI]: {
    en: 'Air Mission',
    tr: 'Hava Görevi',
    ar: 'مهمة جوية',
    es: 'Air Mission',
    it: 'Air Mission',
    ro: 'Air Mission',
  },
  [EFaaliyet.KAZAZEDE]: {
    en: 'Survivor',
    tr: 'Kazazede',
    ar: 'ناجي',
    es: 'Survivor',
    it: 'Survivor',
    ro: 'Survivor',
  },
  [EFaaliyet.IKMAL]: {
    en: 'Supply',
    tr: 'İkmal',
    ar: 'إمداد',
    es: 'Supply',
    it: 'Supply',
    ro: 'Supply',
  },
  [EFaaliyet.MAYIN_DOSEME]: {
    en: 'Lay Mine',
    tr: 'Mayın Döşenme',
    ar: 'زرع الألغام',
    es: 'Lay Mine',
    it: 'Lay Mine',
    ro: 'Lay Mine',
  },
  [EFaaliyet.ENGEL]: {
    en: 'Obstacle',
    tr: 'Engel',
    ar: 'عقبة',
    es: 'Obstacle',
    it: 'Obstacle',
    ro: 'Obstacle',
  },
  [EFaaliyet.MAYIN_TEMIZLEME]: {
    en: 'Clear Mine',
    tr: 'Mayın Temizleme',
    ar: 'إزالة الألغام',
    es: 'Clear Mine',
    it: 'Clear Mine',
    ro: 'Clear Mine',
  },
  [EFaaliyet.FUZE]: {
    en: 'Missile',
    tr: 'Füze',
    ar: 'صاروخ',
    es: 'Missile',
    it: 'Missile',
    ro: 'Missile',
  },
  [EFaaliyet.ISINLANMA]: {
    en: 'Teleport',
    tr: 'Işınlanma',
    ar: 'انتقال آني',
    es: 'Teleport',
    it: 'Teleport',
    ro: 'Teleport',
  },
  [EFaaliyet.TORPIDO_ANGAJMANI]: {
    en: 'Torpedo Engagement',
    tr: 'Torpido Atışı',
    ar: 'اشتباك طوربيد',
    es: 'Torpedo Engagement',
    it: 'Torpedo Engagement',
    ro: 'Torpedo Engagement',
  },
  [EFaaliyet.ANGAJMAN_KURALI]: {
    en: 'Rules Of Engagement',
    tr: 'Angajman Kuralı',
    ar: 'قواعد الاشتباك',
    es: 'Rules Of Engagement',
    it: 'Rules Of Engagement',
    ro: 'Rules Of Engagement',
  },
  [EFaaliyet.DENIZ_TASIMA]: {
    en: 'Maritime Lift',
    tr: 'Deniz Taşıma',
    ar: 'نقل بحري',
    es: 'Maritime Lift',
    it: 'Maritime Lift',
    ro: 'Maritime Lift',
  },
  [EFaaliyet.MUHABERE]: {
    en: 'Communication',
    tr: 'Muhabere',
    ar: 'اتصال',
    es: 'Communication',
    it: 'Communication',
    ro: 'Communication',
  },
  [EFaaliyet.KBRN_ATISI]: {
    en: 'CBRN Attack',
    tr: 'KBRN Atışı',
    ar: 'هجوم كيميائي بيولوجي إشعاعي نووي',
    es: 'CBRN Attack',
    it: 'CBRN Attack',
    ro: 'CBRN Attack',
  },
  [EFaaliyet.BATIYOR]: {
    en: 'Sinking',
    tr: 'Batıyor',
    ar: 'يغرق',
    es: 'Sinking',
    it: 'Sinking',
    ro: 'Sinking',
  },
  [EFaaliyet.ENGEL_DOSEME]: {
    en: 'Lay Obstacles',
    tr: 'Engel Döşeme',
    ar: 'زرع العقبات',
    es: 'Lay Obstacles',
    it: 'Lay Obstacles',
    ro: 'Lay Obstacles',
  },
  [EFaaliyet.ENGEL_TEMIZLEME]: {
    en: 'Remove Obstacles',
    tr: 'Engel Temizleme',
    ar: 'إزالة العقبات',
    es: 'Remove Obstacles',
    it: 'Remove Obstacles',
    ro: 'Remove Obstacles',
  },
  [EFaaliyet.ETMEN_OLUSTURMA]: {
    en: 'Creating Agent',
    tr: 'Etmen Oluşturma',
    ar: 'إنشاء عامل',
    es: 'Creating Agent',
    it: 'Creating Agent',
    ro: 'Creating Agent',
  },
  [EFaaliyet.IKMAL_YUKLEME]: {
    en: 'Loading Supply',
    tr: 'Ikmal Yükleme',
    ar: 'تحميل الإمدادات',
    es: 'Loading Supply',
    it: 'Loading Supply',
    ro: 'Loading Supply',
  },
  [EFaaliyet.DENIZ_KARAKOL_GOREVI]: {
    en: 'Maritime Patrol Mission',
    tr: 'Deniz Karakol Görevi',
    ar: 'مهمة دورية بحرية',
    es: 'Maritime Patrol Mission',
    it: 'Maritime Patrol Mission',
    ro: 'Maritime Patrol Mission',
  },
  [EFaaliyet.SU_ALTI_BOMBA_ANGAJMANI]: {
    en: 'Depth Charge Engagement',
    tr: 'Su Altı Bombası',
    ar: 'اشتباك قنبلة أعماق',
    es: 'Depth Charge Engagement',
    it: 'Depth Charge Engagement',
    ro: 'Depth Charge Engagement',
  },
  [EFaaliyet.DENIZ_CIKMA_ARAMA]: {
    en: 'Maritime Boarding',
    tr: 'Deniz Çıkma Arama',
    ar: 'تفتيش بحري',
    es: 'Maritime Boarding',
    it: 'Maritime Boarding',
    ro: 'Maritime Boarding',
  },
  [EFaaliyet.DENIZ_DOCK]: {
    en: 'Maritime Dock',
    tr: 'Deniz Aracı Binme',
    ar: 'رصيف بحري',
    es: 'Maritime Dock',
    it: 'Maritime Dock',
    ro: 'Maritime Dock',
  },
  [EFaaliyet.DENIZDE_IKMAL]: {
    en: 'Maritime Supply',
    tr: 'Denizde İkmal',
    ar: 'إمداد بحري',
    es: 'Maritime Supply',
    it: 'Maritime Supply',
    ro: 'Maritime Supply',
  },
  [EFaaliyet.DENIZ_ETMENI_HASARLI]: {
    en: 'Maritime Agent Damaged',
    tr: 'Deniz Etmeni Hasarlı',
    ar: 'عامل بحري متضرر',
    es: 'Maritime Agent Damaged',
    it: 'Maritime Agent Damaged',
    ro: 'Maritime Agent Damaged',
  },
  [EFaaliyet.DENIZ_ETMENI_CEKME]: {
    en: 'Maritime Agent Towing',
    tr: 'Deniz Etmeni Çekme',
    ar: 'سحب عامل بحري',
    es: 'Maritime Agent Towing',
    it: 'Maritime Agent Towing',
    ro: 'Maritime Agent Towing',
  },
  [EFaaliyet.ALTYAPI_INSA]: {
    en: 'Build Infrastructure',
    tr: 'Altyapı İnşa',
    ar: 'بناء البنية التحتية',
    es: 'Build Infrastructure',
    it: 'Build Infrastructure',
    ro: 'Build Infrastructure',
  },
  [EFaaliyet.YAKIT_SIZDIRMA]: {
    en: 'Fuel Leaking',
    tr: 'Yakıt Sızdırma',
    ar: 'تسرب الوقود',
    es: 'Fuel Leaking',
    it: 'Fuel Leaking',
    ro: 'Fuel Leaking',
  },
  [EFaaliyet.YAKIT_SIZINTISI]: {
    en: 'Fuel Leaking',
    tr: 'Yakıt Sızıntısı',
    ar: 'تسرب الوقود',
    es: 'Fuel Leaking',
    it: 'Fuel Leaking',
    ro: 'Fuel Leaking',
  },
  [EFaaliyet.TESLIM_OL]: {
    en: 'Surrender',
    tr: 'Teslim Ol',
    ar: 'استسلام',
    es: 'Surrender',
    it: 'Surrender',
    ro: 'Surrender',
  },
  [EFaaliyet.ESIR_AL]: {
    en: 'Capture POW',
    tr: 'Esir Al',
    ar: 'أسر أسير حرب',
    es: 'Capture POW',
    it: 'Capture POW',
    ro: 'Capture POW',
  },
  [EFaaliyet.ESIR_DEVRET]: {
    en: 'Handover POW',
    tr: 'Esir Devret',
    ar: 'تسليم أسير حرب',
    es: 'Handover POW',
    it: 'Handover POW',
    ro: 'Handover POW',
  },
  [EFaaliyet.SERBEST_BIRAK]: {
    en: 'Release POW',
    tr: 'Serbest Bırak',
    ar: 'إطلاق سراح أسير حرب',
    es: 'Release POW',
    it: 'Release POW',
    ro: 'Release POW',
  },
  [EFaaliyet.DENIZ_CIKMA_ELE_GECIRME]: {
    en: 'Maritime Boarding Hijack',
    tr: 'Deniz Çıkma Ele Geçirme',
    ar: 'اختطاف بحري',
    es: 'Maritime Boarding Hijack',
    it: 'Maritime Boarding Hijack',
    ro: 'Maritime Boarding Hijack',
  },
  [EFaaliyet.DENIZ_CIKMA_KURTARMA]: {
    en: 'Maritime Boarding Rescue',
    tr: 'Deniz Çıkma Kurtarma',
    ar: 'إنقاذ بحري',
    es: 'Maritime Boarding Rescue',
    it: 'Maritime Boarding Rescue',
    ro: 'Maritime Boarding Rescue',
  },
  [EFaaliyet.ETMEN_SIL]: {
    en: 'Agent Delete',
    tr: 'Etmen Sil',
    ar: 'حذف عامل',
    es: 'Agent Delete',
    it: 'Agent Delete',
    ro: 'Agent Delete',
  },
  [EFaaliyet.ETMEN_BIRLESTIR]: {
    en: 'Agent Merge',
    tr: 'Etmen Birleştir',
    ar: 'دمج عامل',
    es: 'Agent Merge',
    it: 'Agent Merge',
    ro: 'Agent Merge',
  },
  [EFaaliyet.ETMEN_BOL]: {
    en: 'Agent Divide',
    tr: 'Etmen Böl',
    ar: 'تقسيم عامل',
    es: 'Agent Divide',
    it: 'Agent Divide',
    ro: 'Agent Divide',
  },
  [EFaaliyet.HAVA_GOREVI_OLUSTUR]: {
    en: 'Create Air Mission',
    tr: 'Hava Görevi Oluştur',
    ar: 'إنشاء مهمة جوية',
    es: 'Create Air Mission',
    it: 'Create Air Mission',
    ro: 'Create Air Mission',
  },
  [EFaaliyet.DENIZ_CIKMA_ESIR_ALMA]: {
    en: 'Maritime Boarding Capture',
    tr: 'Deniz Çıkma Esir Alma',
    ar: 'أسر بحري',
    es: 'Maritime Boarding Capture',
    it: 'Maritime Boarding Capture',
    ro: 'Maritime Boarding Capture',
  },
  [EFaaliyet.KARISTIR]: {
    en: 'Jam',
    tr: 'Karıştır',
    ar: 'تشويش',
    es: 'Jam',
    it: 'Jam',
    ro: 'Jam',
  },
  [EFaaliyet.TORPIDO]: {
    en: 'Torpedo',
    tr: 'Torpido',
    ar: 'طوربيد',
    es: 'Torpedo',
    it: 'Torpedo',
    ro: 'Torpedo',
  },
  [EFaaliyet.SU_ALTI_BOMBA]: {
    en: 'Depth Charge',
    tr: 'Su Altı Bomba',
    ar: 'قنبلة أعماق',
    es: 'Depth Charge',
    it: 'Depth Charge',
    ro: 'Depth Charge',
  },
  [EFaaliyet.KARA_KARA_FUZESI_ANGAJMANI]: {
    en: 'Surface to Surface Missile Engagement',
    tr: 'Karadan Karaya Füze Angajmanı',
    ar: 'اشتباك صاروخي أرض-أرض',
    es: 'Surface to Surface Missile Engagement',
    it: 'Surface to Surface Missile Engagement',
    ro: 'Surface to Surface Missile Engagement',
  },
  [EFaaliyet.SEYIR_FUZESI_ANGAJMANI]: {
    en: 'Cruise Missile Engagement',
    tr: 'Seyir Füzesi Angajmanı',
    ar: 'اشتباك صاروخ كروز',
    es: 'Cruise Missile Engagement',
    it: 'Cruise Missile Engagement',
    ro: 'Cruise Missile Engagement',
  },
  [EFaaliyet.PUSU]: {
    en: 'Ambush',
    tr: 'Pusu',
    ar: 'كمين',
    es: 'Ambush',
    it: 'Ambush',
    ro: 'Ambush',
  },
  [EFaaliyet.BASKIN]: {
    en: 'Raid',
    tr: 'Baskın',
    ar: 'غارة',
    es: 'Raid',
    it: 'Raid',
    ro: 'Raid',
  },
  [EFaaliyet.BEKLEMEDE]: {
    en: 'On Standby',
    tr: 'Beklemede',
    ar: 'في الانتظار',
    es: 'On Standby',
    it: 'On Standby',
    ro: 'On Standby',
  },
  [EFaaliyet.TASINIYOR]: {
    en: 'Relocating',
    tr: 'Taşınıyor',
    ar: 'يتم نقله',
    es: 'Relocating',
    it: 'Relocating',
    ro: 'Relocating',
  },
  [EFaaliyet.CEKILIYOR]: {
    en: 'Being Towed',
    tr: 'Çekiliyor',
    ar: 'يتم سحبه',
    es: 'Being Towed',
    it: 'Being Towed',
    ro: 'Being Towed',
  },
  [EFaaliyet.YENI_HACIM]: {
    en: 'New Volume',
    tr: 'Yeni Hacim',
    ar: 'حجم جديد',
    es: 'New Volume',
    it: 'New Volume',
    ro: 'New Volume',
  },
  [EFaaliyet.BINA_TEMIZLIGI]: {
    en: 'Clearing Building',
    tr: 'Bina Temizliği',
    ar: 'تطهير المبنى',
    es: 'Clearing Building',
    it: 'Clearing Building',
    ro: 'Clearing Building',
  },
  [EFaaliyet.MANIFESTODAN_CIKARMA]: {
    en: 'Removing From Manifest',
    tr: 'Manifestodan Çıkarma',
    ar: 'إزالة من القائمة',
    es: 'Removing From Manifest',
    it: 'Removing From Manifest',
    ro: 'Removing From Manifest',
  },
  [EFaaliyet.ARAMA_KURTARMA]: {
    en: 'Search And Rescue',
    tr: 'Arama Kurtarma',
    ar: 'بحث وإنقاذ',
    es: 'Search And Rescue',
    it: 'Search And Rescue',
    ro: 'Search And Rescue',
  },
  [EFaaliyet.GOCUK_ALTINDA]: {
    en: 'Under The Rubble',
    tr: 'Gocuk Altinda',
    ar: 'تحت الأنقاض',
    es: 'Under The Rubble',
    it: 'Under The Rubble',
    ro: 'Under The Rubble',
  },
  [EFaaliyet.KURTARILAN]: {
    en: 'Rescued',
    tr: 'Kurtarilan',
    ar: 'تم إنقاذه',
    es: 'Rescued',
    it: 'Rescued',
    ro: 'Rescued',
  },
  [EFaaliyet.BAKIM]: {
    en: 'Maintainance',
    tr: 'Bakim',
    ar: 'صيانة',
    es: 'Maintainance',
    it: 'Maintainance',
    ro: 'Maintainance',
  },
  [EFaaliyet.KARA_TASIMA]: {
    en: 'Land Lifting',
    tr: 'Kara Tasima',
    ar: 'نقل بري',
    es: 'Land Lifting',
    it: 'Land Lifting',
    ro: 'Land Lifting',
  },
  [EFaaliyet.KARA_BINDIRILDI]: {
    en: 'Land Embarked',
    tr: 'Kara Bindirildi',
    ar: 'تم تحميله برياً',
    es: 'Land Embarked',
    it: 'Land Embarked',
    ro: 'Land Embarked',
  },
  [EFaaliyet.YORUNGE_ETRAFINDA_DONME]: {
    en: 'ROTATE AROUND ORBIT',
    tr: 'Yorunge Etrafinda Donme',
    ar: 'الدوران حول المدار',
    es: 'ROTATE AROUND ORBIT',
    it: 'ROTATE AROUND ORBIT',
    ro: 'ROTATE AROUND ORBIT',
  },
  [EFaaliyet.SONOBUOY]: {
    en: 'Sonobuoy',
    tr: 'Sonoşamandira',
    ar: 'عوامة صوتية',
    es: 'Sonobuoy',
    it: 'Sonobuoy',
    ro: 'Sonobuoy',
  },
  [EFaaliyet.AFETZEDE]: {
    en: 'Disaster Victim',
    tr: 'Afetzede',
    ar: 'زائ العواصف',
    es: 'Disaster Victim',
    it: 'Disaster Victim',
    ro: 'Disaster Victim',
  },
};

export default data;
